import clsx from 'clsx';
import type { CellContext } from '@tanstack/react-table';
import { memo } from 'react';
import { Typography } from '@mui/material';

interface Props<T, P> {
  value: [Date, Date | null];
  row: CellContext<T, P>;
  onClick?: (row: T, cell: keyof P, newRow?: T) => unknown;
}

const DateRangeBase = <T, P>({ value }: Props<T, P>) => {
  const [from, to] = value;

  return (
    <>
      <Typography variant="subtitle2" className={clsx('text-sm cursor-pointer hover:font-bold transition-all', !value && 'text-gray-500 italic')}>
        {to ? `${from.getDate()}.${from.getMonth()}. - ${to.getDate()}.${to.getMonth()}.` : `${from.getDate()}.${from.getMonth()}.`}
      </Typography>
    </>
  );
};

export const DateRange = memo(DateRangeBase) as typeof DateRangeBase;
